module.exports = "<br>\n<nav class=\"col-12\"> \n\t<button type=\"button\" class=\"col-12 col-sm-2 btn-red\" routerLink=\"./list\" routerLinkActive=\"active\" > Lista de horarios </button> \n\t<button  type=\"button\" class=\"col-12 col-sm-2 btn-red\" routerLink=\"./new\" routerLinkActive=\"active\">  Nuevo horario </button> \n</nav>\n\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/schedule/schedule/schedule.component.html
// module id = ../../../../../src/app/admin/schedule/schedule/schedule.component.html
// module chunks = schedule.module